import { Component, h } from 'preact';

import get from '../utils/get';
import getQueryString from '../utils/get-query-string';
import Promise from '../utils/promise';

import LegeStream from './legestream';
import StreamTab from './stream-tab';

const CONVENE_TIME_URL =
  'https://apps.texastribune.org/data/85th-texas-legislature/convene-times.json';
const CAMERA_STATUS_URL =
  'https://apps.texastribune.org/data/85th-texas-legislature/camera-status.json';

export default class LegeViewer extends Component {
  constructor() {
    super();

    this.state = {
      activeChamber: 'house',
      houseTime: '',
      senateTime: '',
      houseIsLive: false,
      senateIsLive: false
    };

    this.onCameraToggle = this.onCameraToggle.bind(this);
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    const { stream } = getQueryString(window.location.search);

    if (stream === 'senate') {
      this.setState({ activeChamber: 'senate' });
    }

    this.update();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  update() {
    const conveneUpdate = get(CONVENE_TIME_URL).then(JSON.parse);
    const cameraUpdate = get(CAMERA_STATUS_URL).then(JSON.parse);

    Promise.all([conveneUpdate, cameraUpdate])
      .then(([times, cameras]) => {
        this.setState({
          houseTime: times.house,
          senateTime: times.senate,
          houseIsLive: cameras.house,
          senateIsLive: cameras.senate
        });

        this.timer = setTimeout(this.update, 1000 * 60 * 5);
      })
      .catch(err => console.error(err));
  }

  onCameraToggle(activeChamber) {
    if (this.state.activeChamber !== activeChamber) {
      this.setState({ activeChamber });
    }
  }

  render() {
    const {
      activeChamber,
      houseTime,
      senateTime,
      houseIsLive,
      senateIsLive
    } = this.state;

    const { shouldAutoplay, includeInfo } = this.props;

    const placeholderClass = `stream-placeholder stream-placeholder--${activeChamber}`;

    const turnOnCamera =
      (activeChamber === 'house' && houseIsLive) ||
      (activeChamber === 'senate' && senateIsLive);

    const viewerClasses = `lege-viewer${includeInfo === false ? ' lege-viewer--minimal' : ''}`;

    return (
      <div class={viewerClasses}>
        <div class="stream-controls">
          <StreamTab
            chamber="house"
            info={houseTime}
            isLive={houseIsLive}
            onClick={this.onCameraToggle}
            isActive={activeChamber === 'house'}
            includeInfo={includeInfo}
          />
          <StreamTab
            chamber="senate"
            info={senateTime}
            isLive={senateIsLive}
            onClick={this.onCameraToggle}
            isActive={activeChamber === 'senate'}
            includeInfo={includeInfo}
          />
        </div>
        <div class={placeholderClass} id="stream-container">
          {turnOnCamera &&
            <LegeStream
              chamberId={activeChamber}
              shouldAutoplay={shouldAutoplay}
            />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/lege-viewer.js